import React, { useState, useEffect, useRef } from 'react'

import { useDispatch } from 'react-redux'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PersonalBasicInfo from '../../../widgets/personalBasicInfo/PersonalBasicInfo'
import AddressWork from '../../../widgets/address/addressWork/AddressWork'
import AddressCard from '../../../widgets/address/addressCard/AddressCard'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import AddressDeliveryDocument from '../../../widgets/address/addressDeliveryDocument/AddressDeliveryDocument'
import { Panel, Checkbox, Modal, Button, Row, Message } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import {
  getResponsinator,
  getSchemaProposalResponsinatorBasicInfo,
  updateSchemaProposalResponsinatorBasicInfo,
} from '../../../redux/actions/proposalResponsinator'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import CurrentAddress from '../../../widgets/address/currentAddress/CurrentAddress'
import QualificationResponsibleWidget from '../../../widgets/qualificationResponsible/QualificationResponsibleWidget'
import pathname from '../../../constants/pathname'
import CustomAlertMessageInfo from '../../../widgets/CustomAlertMessageInfo'
import CustomNote from '../../../widgets/CustomNote'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import '../styles.less'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ProposalResponsibleManBasicInfo() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [addressWork, setAddressWork] = useState()
  const [addressCard, setAddressCard] = useState()
  const [showConfirm, setShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isViewPrevious, setIsViewPrevious] = useState(false)
  const [error, setError] = useState()
  const [isError, setIsError] = useState(false)
  const [sameGranteeInfo, setSameGranteeInfo] = useState()

  const previousPanelRef = useRef(null)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  const [responsibleProjectData, setResponsibleProjectData] = useState()

  const type = 'responsinator'

  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.granteeProperty}`,
    pathNameForward: `${pathname.proposal.granteeBasicInfo}`,
  }

  useEffect(() => {
    if (projectId) handleGetSchema()
    else setError({ statusCode: 404, errorMessage: ERR_MSG_404_PROJECT_ID })
  }, [])

  useEffect(() => {
    if (isViewPrevious && schemaPrevious) {
      previousPanelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [isViewPrevious, schemaPrevious])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaProposalResponsinatorBasicInfo(projectId)
      setSameGranteeInfo(_schema?.forms?.responsinatorInfo?.sameGrantee.value)
      setAddressWork(initAddress(_schema?.forms?.currentAddress))
      setAddressCard(initAddress(_schema?.forms?.idCardAddress))
      setSchema(_schema)
      setIsEditWidget({
        persomal: _schema.forms?.persomal?.id ? false : true,
        currentAddress: _schema.forms?.currentAddress?.id ? false : true,
        idCardAddress: _schema.forms?.idCardAddress?.id ? false : true,
        documentAddress: _schema.forms?.documentAddress?.id ? false : true,
        companyAddress: _schema.forms?.companyAddress?.id ? false : true,
        qualificationResponsible: _schema.forms?.qualificationResponsible?.id ? false : true,
      })
    } catch (e) {
      setError(
        e?.response?.data
          ? { statusCode: e.response.data.status, errorMessage: e.response.data.errors?.message }
          : {}
      )
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
      } else if (schemaPrevious) {
        setIsViewPrevious(true)
      } else {
        const _schema = await getSchemaProposalResponsinatorBasicInfo(id)
        setSchemaPrevious(_schema)
        setIsViewPrevious(true)
      }
    } catch (e) {
      console.error(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnSubmitAddressWork = (value) => {
    setAddressWork(value)
  }

  const handleOnSubmitAddressCard = (value) => {
    setAddressCard(value)
  }

  const handleSaveSameGranteeInfo = async () => {
    let request = { projectVersionId: projectId, sameGrantee: sameGranteeInfo }
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const _schema = await updateSchemaProposalResponsinatorBasicInfo(projectId, request)
      setSameGranteeInfo(_schema?.forms?.responsinatorInfo?.sameGrantee.value)
      setSchema(_schema)
      setIsEditAll(!sameGranteeInfo, isEditWidget, setIsEditWidget)
      setShowConfirm(false)
      await dispatch(getSchemaSidebar(projectId))
    } catch (e) {
      setIsError(true)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetResponsibleProjectSchema = async () => {
    console.log('handleGetResponsibleProjectSchema : ')

    startLoading()
    try {
      const response = await getResponsinator(projectId)
      console.log('response : ', response)

      setResponsibleProjectData(response)
    } catch (e) {
      console.log(e)
    }
    doneLoading()
  }

  const handleUpdateSchema = async () => {
    let request = {
      projectVersionId: projectId,
      sameGrantee: sameGranteeInfo,
    }

    setIsLoading(true)
    startLoading()
    // setIsError(false)
    try {
      const _schema = await updateSchemaProposalResponsinatorBasicInfo(projectId, request)
      setSameGranteeInfo(_schema?.forms?.responsinatorInfo?.sameGrantee.value)
      setSchema(_schema)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const initAddress = (address) => ({
    buildingName: address?.buildingName?.value,
    roomNumber: address?.roomNumber?.value,
    houseNumber: address?.houseNumber?.value,
    villageNumber: address?.villageNumber?.value,
    lane: address?.lane?.value,
    villageName: address?.villageName?.value,
    road: address?.road?.value,
    location: address?.location?.value,
    telephone: address?.telephone?.value,
    mobile: address?.mobile?.value,
    fax: address?.fax?.value,
    email: address?.email?.value,
  })

  const renderResponsibleVersion = ({ currentSchema, isCurrent }) => {
    const responsinatorDisabled = isCurrent
      ? currentSchema?.forms?.responsinatorInfo?.disabled
      : true
    const sameGranteeChecked = isCurrent
      ? sameGranteeInfo
      : currentSchema?.forms?.responsinatorInfo?.sameGrantee?.value

    return (
      <div className={isCurrent ? 'top' : 'bottom'}>
        {currentSchema?.forms?.responsinatorInfo && (
          <>
            <Panel header={currentSchema.forms.responsinatorInfo.header} shaded>
              <div className="proposal-responsible-man-panel-body">
                <CustomAlertMessageInfo
                  contents={currentSchema.forms.responsinatorInfo.description}
                />
                {currentSchema.forms.responsinatorInfo.descriptionNote && (
                  <div className="proposal-responsible-man-note">
                    <CustomNote data={currentSchema.forms.responsinatorInfo.descriptionNote} />
                  </div>
                )}
                {!currentSchema.forms.responsinatorInfo.hideSameGrantee && (
                  <>
                    <Checkbox
                      checked={sameGranteeChecked}
                      disabled={responsinatorDisabled}
                      onChange={(value, checked) => isCurrent && setSameGranteeInfo(checked)}
                    >
                      {currentSchema.forms.responsinatorInfo.sameGrantee.label}
                    </Checkbox>
                    {isCurrent && !responsinatorDisabled && (
                      <>
                        <hr />
                        {isError && (
                          <Row className="proposal-responsible-man-error">
                            <Message
                              showIcon
                              type="error"
                              description={'เกิดข้อผิดพลาดในการบันทึก'}
                            />
                          </Row>
                        )}
                        <SaveButton
                          onClick={() => setShowConfirm(true)}
                          disabled={
                            currentSchema.forms.responsinatorInfo.sameGrantee.value ===
                            sameGranteeInfo
                          }
                        />
                      </>
                    )}
                  </>
                )}
              </div>
            </Panel>
            <br />
          </>
        )}

        {currentSchema?.forms?.persomal && (
          <>
            <PersonalBasicInfo
              showCommandButton={isCurrent && !currentSchema.forms.persomal.disabled}
              honorificOptions={currentSchema.forms.honorificOptions}
              isEdit={isCurrent && isEditWidget.persomal && !currentSchema.forms.persomal.disabled}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('persomal', _isEdit, setIsEditWidget)
              }
              schema={currentSchema.forms.persomal}
              type={type}
              updateSchema={isCurrent ? handleUpdateSchema : undefined}
            />
            <br />
          </>
        )}
        {currentSchema?.forms?.currentAddress && (
          <>
            <CurrentAddress
              showCommandButton={isCurrent && !currentSchema.forms.currentAddress.disabled}
              schema={currentSchema.forms.currentAddress}
              isEdit={
                isCurrent &&
                isEditWidget.currentAddress &&
                !currentSchema.forms.currentAddress.disabled
              }
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('currentAddress', _isEdit, setIsEditWidget)
              }
              handleOnSubmit={isCurrent ? (val) => setAddressWork(val) : undefined}
              type={type}
            />
            <br />
          </>
        )}
        {currentSchema?.forms?.idCardAddress && (
          <>
            <AddressCard
              showCommandButton={isCurrent && !currentSchema.forms.idCardAddress.disabled}
              isEdit={
                isCurrent &&
                isEditWidget.idCardAddress &&
                !currentSchema.forms.idCardAddress.disabled
              }
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('idCardAddress', _isEdit, setIsEditWidget)
              }
              handleOnSubmit={isCurrent ? (val) => setAddressCard(val) : undefined}
              schema={currentSchema.forms.idCardAddress}
              addressWork={addressWork}
              type={type}
            />
            <br />
          </>
        )}
        {currentSchema?.forms?.documentAddress && (
          <>
            <AddressDeliveryDocument
              showCommandButton={isCurrent && !currentSchema.forms.documentAddress.disabled}
              schema={currentSchema.forms.documentAddress}
              isEdit={
                isCurrent &&
                isEditWidget.documentAddress &&
                !currentSchema.forms.documentAddress.disabled
              }
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('documentAddress', _isEdit, setIsEditWidget)
              }
              addressWork={addressWork}
              addressCard={addressCard}
              type={type}
            />
            <br />
          </>
        )}
        {currentSchema?.forms?.companyAddress && (
          <>
            <AddressWork
              showCommandButton={isCurrent && !currentSchema.forms.companyAddress.disabled}
              schema={currentSchema.forms.companyAddress}
              isEdit={
                isCurrent &&
                isEditWidget.companyAddress &&
                !currentSchema.forms.companyAddress.disabled
              }
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('companyAddress', _isEdit, setIsEditWidget)
              }
              type={type}
            />
            <br />
          </>
        )}
        {currentSchema?.forms?.qualificationResponsible && (
          <>
            <QualificationResponsibleWidget
              showCommandButton={
                isCurrent && !currentSchema.forms.qualificationResponsible.disabled
              }
              schema={currentSchema.forms.qualificationResponsible}
              isEdit={
                isCurrent &&
                isEditWidget.qualificationResponsible &&
                !currentSchema.forms.qualificationResponsible.disabled
              }
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('qualificationResponsible', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}
      </div>
    )
  }

  if (error)
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )

  if (!schema || isLoading)
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon
        handleGetSchemaPrevious={handleGetSchemaPrevious}
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1031,5-5016'}
      />

      <BtnEditAll
        onClickEditAll={getIsEditAll(isEditWidget)}
        routing={buttonRoute}
        hiddenBtnEdit={isViewPrevious}
        setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
        editWidget={isEditWidget}
        forms={schema?.forms}
      />

      <div
        className="wrapper proposal-responsible-man-page"
        style={{ display: 'block', width: '100%' }}
      >
        <div style={{ width: '100%', minWidth: 0 }}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '700px', overflowY: 'auto', width: '100%' }}
            >
              <div style={{ padding: 0, width: '100%' }}>
                {renderResponsibleVersion({ currentSchema: schema, isCurrent: true })}
              </div>
            </Panel>
          ) : (
            renderResponsibleVersion({ currentSchema: schema, isCurrent: true })
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <div
            ref={previousPanelRef}
            className="proposal-responsible-man-previous"
            style={{ width: '100%', minWidth: 0, marginTop: '16px' }}
          >
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ก่อนหน้า'}
              style={{
                maxHeight: '700px',
                overflowY: 'auto',
                width: '100%',
                backgroundColor: '#e4e4ed',
              }}
            >
              <div
                className="bottom proposal-responsible-man-previous-body"
                style={{ padding: '0', width: '100%' }}
              >
                {renderResponsibleVersion({ currentSchema: schemaPrevious, isCurrent: false })}
              </div>
            </Panel>
            <br />
            <br />
          </div>
        )}
      </div>

      <Modal
        size="sm"
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        style={{ marginTop: '5%' }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการแก้ไข</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>ข้อมูลผู้รับผิดชอบโครงการทั้งหมด จะถูกเปลี่ยนเป็นข้อมูลเหมือนของผู้รับทุนทั้งหมด</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSaveSameGranteeInfo} appearance="primary">
            ยืนยัน
          </Button>
          <Button onClick={() => setShowConfirm(false)} appearance="subtle">
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </SidebarProposal>
  )
}
